import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { Box, Button } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import { StyledFormContainer } from '../../FormField/StyledFormContainer';
import VMSFormContainer from '../containers/VMSFormContainer';

import BuildingsSettingsListComponent from '../../Settings/BuildingsSettingsListComponent';
import HeaderComponent from '../../Settings/HeaderComponent';

const VMSListComponent = ({
  buildings,
  buildingsID,
  putVisitorKeysData,
  name,
  getBuildingData,
  form,
  id,
  visitorKeys,
  prevId,
  hasBuildingsList,
  isMobileScreen,
}) => {
  const { t } = useTransl();
  // do not show buildings list on mobile devices by default
  const [isListDisplayed, setIsListDisplayed] = useState(
    !isMobileScreen && hasBuildingsList,
  );

  useEffect(() => {
    setIsListDisplayed(!isMobileScreen);
  }, [isMobileScreen]);

  const formContainerId = 'visitorSettingsForm';

  const buildingListButtonTitle = isListDisplayed
    ? t('building.hideBuildingsList')
    : t('building.showBuildingsList');

  const onBuildingClick = (event) => {
    getBuildingData(event);
    isMobileScreen && setIsListDisplayed(false);
  };

  return (
    <Box mt={2}>
      <HeaderComponent id={id} name={name} />

      {isMobileScreen && hasBuildingsList && (
        <Button onClick={() => setIsListDisplayed(!isListDisplayed)} fullWidth>
          {buildingListButtonTitle}
        </Button>
      )}

      <Box display="flex" width="100%">
        {hasBuildingsList && isListDisplayed && (
          <BuildingsSettingsListComponent
            maxHeight="70vh"
            buildings={buildings}
            selectedBuildingId={prevId}
            onBuildingClick={onBuildingClick}
          />
        )}

        <StyledFormContainer
          sx={{ minHeight: '60rem' }}
          id={formContainerId}
          hasVisibleList={hasBuildingsList && isListDisplayed}
          hasHiddenList={isMobileScreen && isListDisplayed}
        >
          <VMSFormContainer
            buildingsID={buildingsID}
            putVisitorKeysData={putVisitorKeysData}
            form={form}
            {...visitorKeys}
          />
        </StyledFormContainer>
      </Box>
    </Box>
  );
};

VMSListComponent.defaultProps = {
  PMCId: null,
  prevId: null,
  buildings: [],
  buildingsID: [],
};

VMSListComponent.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  hasBuildingsList: PropTypes.bool.isRequired,
  isMobileScreen: PropTypes.bool.isRequired,
  putVisitorKeysData: PropTypes.func.isRequired,
  getBuildingData: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  form: PropTypes.instanceOf(Object).isRequired,
  visitorKeys: PropTypes.instanceOf(Object).isRequired,
  prevId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  PMCId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  buildings: PropTypes.instanceOf(Array),
  buildingsID: PropTypes.instanceOf(Array),
};

export default VMSListComponent;
